
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tra-cuu-van-don/[ids]",
      function () {
        return require("private-next-pages/tra-cuu-van-don/[ids].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tra-cuu-van-don/[ids]"])
      });
    }
  